import { useDispatch, useSelector } from 'react-redux';
import { selectDomesticHelperFormData, saveDomesticHelperFormData } from '../redux/features/domesticHelperFormSlice';

const useDomesticHelperFormData = (formName) => {
  const dispatch = useDispatch();
  const formData = useSelector(selectDomesticHelperFormData);

  const saveDomesticHelperDataInRedux = (data) => {
    dispatch(saveDomesticHelperFormData({ formName, data }));
  };

  const getDomesticHelperFormData = () => {
    return formData[formName] || null;
  };

  return {
    saveDomesticHelperDataInRedux,
    getDomesticHelperFormData,
  };
};

export default useDomesticHelperFormData;